// extracted by mini-css-extract-plugin
export default {"about":"menu_about__YCRI2","fonz":"menu_fonz__XUCXk","aboutBurger":"menu_aboutBurger__6LsEQ","wingsBox":"menu_wingsBox__dY7Mr","wingz":"menu_wingz__D6y+G"};